import { useSelector } from "react-redux";
import { useStateList } from "./HandleInvoiceStateProvider";

export const BOS_TAXABILITY_VALUES = [-1,2, 3, 5, 7, 9];
export const NIL_TAXABILITY_VALUE = -1;
export const NON_GST_TAXABILITY_VALUES = [...BOS_TAXABILITY_VALUES, NIL_TAXABILITY_VALUE];
export const HIDE_GST_COLUMN_TAXABILITY_VALUES = [2, 3, 5, NIL_TAXABILITY_VALUE];

export const isNilTaxability = (value) => Number(value) === NIL_TAXABILITY_VALUE;

export const isBosTaxability = (value) =>
  BOS_TAXABILITY_VALUES.includes(Number(value));

export const isNonGstTaxability = (value) =>
  NON_GST_TAXABILITY_VALUES.includes(Number(value));

export const hidesGstColumn = (value) =>
  HIDE_GST_COLUMN_TAXABILITY_VALUES.includes(Number(value));

/**
 * NIL is valid on both BOS and Tax Invoice series — never auto-switch for it.
 * Empty/null prev means taxability was cleared (e.g. after a manual series change);
 * do not re-pick series when the user is only filling taxability again.
 */
export const shouldSwitchSeriesForTaxability = (prevValue, nextValue) => {
  if (isNilTaxability(prevValue) || isNilTaxability(nextValue)) return false;
  if (prevValue === "" || prevValue == null) return false;
  return isBosTaxability(prevValue) !== isBosTaxability(nextValue);
};

/** Required voucher serialflag for a taxability on Sales/POS (1 = BOS, 0 = Tax Invoice). */
export const getRequiredSerialFlagForTaxability = (taxVal, { type } = {}) => {
  const isSalesOrPos = type === "Sales" || type === "Pos";
  return isSalesOrPos && isBosTaxability(taxVal) ? 1 : 0;
};

/** Net amount / journal: zero-GST taxability list (includes RCM `4` for customer/POS). */
export const getEntryTaxTypes = (partyType, type) =>
  partyType === "CUSTOMER" || type === "Pos"
    ? [...NON_GST_TAXABILITY_VALUES, 4]
    : [...NON_GST_TAXABILITY_VALUES];

/** `invoicemaster.taxability` save field: 3 = BOS-style, 1 = Tax invoice. */
export const getInvoiceDocumentTaxType = (taxabilityValue, { type, companyType } = {}) => {
  if (Number(companyType) === 3) return 3;
  const isSalesOrPos = type === "Sales" || type === "Pos";
  if (isSalesOrPos && isNonGstTaxability(taxabilityValue)) return 3;
  return 1;
};

// Custom Hook
export const useTaxabilityOptions = () => {
    const {partyType,invoiceEntry,data}=useStateList()
  
    
  const getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  const companyType =
    getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
 let partyTypeCD=invoiceEntry?.length===0?partyType:invoiceEntry?.partytypecd
 let stateValueCD=invoiceEntry?.length===0?data.placeOfSupply.value:invoiceEntry?.placeofsupply
 
 
  const gstOrCompositeRate = [
    {id:-1,rate:"NIL"},
    { id: 0, rate: "0%" },
    { id: 3, rate: "3%" },
    { id: 5, rate: "5%" },
  
    { id: 12, rate: "12%" },
    { id: 18, rate: "18%" },
    { id: 28, rate: "28%" },
      { id: 40, rate: "40%" },
  ];

  const compositeRate = [
    { id: 1, rate: "1%" },
    { id: 2, rate: "2%" },
    { id: 3, rate: "3%" },
    { id: 5, rate: "5%" },
    { id: 6, rate: "6%" },
  ];

  const allTaxabilityOptions = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER" ? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label:(partyTypeCD==="SUPPLIER" && stateValueCD == 96) ? "Reverse Charge on Foreign Supplies":"GST Reverse Charge", value: 4 },
    { label: "Out of scope", value: 5 },

    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies With Tax Payment"
          : "SEZ With Tax Payment",
      value: 6,
    },
    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies Without Tax Payment"
          : "SEZ Without Tax Payment",
      value: 7,
    },
    { label: "Export With Tax Payment", value: 8 },
    { label: "Export Without Tax Payment", value: 9 },
    { label: "NIL", value: NIL_TAXABILITY_VALUE },
  ];

  const taxabilityOptions = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER" ? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "GST Reverse Charge", value: 4 },
    { label: "Out of scope", value: 5 },
    { label: "NIL", value: -1 },
  ];
  const taxabilityOptionsPos = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER" ? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "Out of scope", value: 5 },
    { label: "NIL", value: -1 },
  ];

  const compositeTaxability = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER" ? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    { label: "GST Reverse Charge", value: 4 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "Out of scope", value: 5 },
    { label: "NIL", value: -1 },
  ];
  const compositeTaxabilityForCustomer = [
    { label: companyType == 3 && partyTypeCD==="CUSTOMER"? "Composition-Taxable" : "Taxable", value: 1 },
    { label: "Exempted", value: 2 },
    // { label: "GST Reverse Charge", value: 4 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "Out of scope", value: 5 },
  ];

  const taxabilityOutsideIndia = partyTypeCD==="SUPPLIER"?[
    { label: "Reverse Charge on Foreign Supplies", value: 4 },
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "Out of scope", value: 5 },
  ]:[
    { label: "Export With Tax Payment", value: 8 },
    { label: "Export Without Tax Payment", value: 9 },
  ];

  const compositeSupplierTaxability = [
    { label: "GST Reverse Charge", value: 4 },
  ];

  const unrSupplierTaxability = [
    { label: "Exempted", value: 2 },
    { label: "Non-Taxable(Non-GST)", value: 3 },
    { label: "GST Reverse Charge", value: 4 },
    { label: "Out of scope", value: 5 },
    { label: "NIL", value: -1 },
  ];

  const customerTaxabilityOptions = [
    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies With Tax Payment"
          : "SEZ With Tax Payment",
      value: 6,
    },
    {
      label:
        partyTypeCD === "SUPPLIER"
          ? "SEZ Supplies Without Tax Payment"
          : "SEZ Without Tax Payment",
      value: 7,
    },
  ];

  return {
    gstOrCompositeRate,
    compositeRate,
    allTaxabilityOptions,
    taxabilityOptions,
    compositeTaxability,
    taxabilityOutsideIndia,
    compositeSupplierTaxability,
    unrSupplierTaxability,
    customerTaxabilityOptions,
    compositeTaxabilityForCustomer,
    taxabilityOptionsPos
  };
};
